import {v4 as uuid } from 'uuid';

export default function selectCalendar (calendar) {
    const appStore = this.env.appStore;
    this.selectedCalendar = calendar;
    this.observed.selectedCalendar = uuid();
    appStore.checkCalendar(calendar);
}
